import React from 'react';
import SocialMediaAction from '../features/SocialMediaAction.tsx';
import './HomePage.css';
import '../css/grid.css';

const HomePage = () => {

    return <div className="container home-page">
        <div className='row'>
            <div className='column-8'>
                <h1 className='greeting-text'>Welcome to Super Dimension Gaming, a Wimberley community table-top game event space!</h1>
            </div>
        </div>npm install @types/react
        <div className='row gap-row'></div>
        <div className='row'>
            <div className='column-3'></div>
            {/* <div className='column-5'>
                <a className='event-registration-text' href="https://wimberleyparksandrec.com/community-center/super-dimension-gaming/"><h1>Register for a board game event &gt;</h1></a>
            </div> */}
            <div className='column-4'></div>
        </div>
        <div className='row'>
            <div className='column-12'>
                <h2 className='action-text'>Follow us on social media for updates!</h2>
            </div>
        </div>
        <div className='row'>
            <div className="column-12">
                <SocialMediaAction />
            </div>
        </div>
    </div>
}

export default HomePage;